export function initHellobar() {
	const hellobar = document.querySelector(".hellobar");

	function handleClick(event) {
		event.preventDefault();

		const link = event.target.closest(".hellobar__link");
		if (!link) return;

		const url = link.getAttribute("href");
		const parent = link.closest(".hellobar");
		const id = parent.getAttribute("id");
		const modified = parent.dataset.modified;

		localStorage.setItem(id, modified);
		parent.style.display = "none";
		window.location.href = url;
	}

	document.body.addEventListener("click", (event) => {
		if (event.target.closest(".hellobar__link")) {
      handleClick(event);
		}
	});

	if (hellobar !== null) {
		const hellobarStorage = parseInt(localStorage.getItem(hellobar.id));

		if (hellobarStorage !== parseInt(hellobar.dataset.modified)) {
			hellobar.style.display = "flex";
		}
	}
}
